import React from 'react';
import { useNavigate } from 'react-router-dom';
import './styles.css';

const CompetitorCard = ({ competitor }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`/profile/${competitor.username}`);
    };

    const fullName = `${competitor.firstName || ''} ${competitor.lastName || ''}`.trim();
    const initials = `${(competitor.firstName || '?')[0]}${(competitor.lastName || '?')[0]}`.toUpperCase();

    const formatDistance = (km) => {
        if (km >= 1000) return `${(km / 1000).toFixed(1)}k km`;
        return `${Math.round(km)} km`;
    };

    const getActivityIcon = (activityType) => {
        const iconMap = {
            'running': 'bi-person-walking',
            'cycling': 'bi-bicycle',
            'swimming': 'bi-water',
            'hiking': 'bi-tree',
            'walking': 'bi-person-walking',
            'football': 'bi-trophy',
            'badminton': 'bi-circle',
            'other': 'bi-activity'
        };
        return iconMap[activityType?.toLowerCase()] || 'bi-activity';
    };

    const getActivityIconColor = (activityType) => {
        const colorMap = {
            'running': 'text-danger',
            'cycling': 'text-primary',
            'swimming': 'text-info',
            'hiking': 'text-success',
            'walking': 'text-secondary',
            'football': 'text-warning',
            'badminton': 'text-primary',
            'other': 'text-muted'
        };
        return colorMap[activityType?.toLowerCase()] || 'text-muted';
    };

    const formattedSport = competitor.topSport
        ? competitor.topSport.charAt(0).toUpperCase() + competitor.topSport.slice(1)
        : null;

    return (
        <div className="competitor-card" onClick={handleClick} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && handleClick()}>
            <div className="competitor-card-header">
                {competitor.profilePicture ? (
                    <img
                        src={competitor.profilePicture}
                        alt={fullName}
                        className="competitor-avatar"
                    />
                ) : (
                    <div className="competitor-avatar competitor-avatar-placeholder" title={fullName}>
                        {initials}
                    </div>
                )}
                <div className="competitor-info">
                    <h3 className="competitor-name">{fullName}</h3>
                </div>
            </div>

            <div className="competitor-stats">
                <div className="stat-item">
                    <span className="stat-value">{competitor.totalActivities || 0}</span>
                    <span className="stat-label">Activities</span>
                </div>
                <div className="stat-item">
                    <span className="stat-value">{formatDistance(competitor.totalDistance || 0)}</span>
                    <span className="stat-label">Distance</span>
                </div>
                <div className="stat-item">
                    {formattedSport ? (
                        <>
                            <span className="stat-value">
                                <i className={`bi ${getActivityIcon(competitor.topSport)} ${getActivityIconColor(competitor.topSport)}`}></i>
                            </span>
                            <span className="stat-label">{formattedSport}</span>
                        </>
                    ) : (
                        <>
                            <span className="stat-value">—</span>
                            <span className="stat-label">Sport</span>
                        </>
                    )}
                </div>
            </div>

            {competitor.activeCompetitionsCount > 0 && (
                <div className="competitor-active-badge">
                    {competitor.activeCompetitionsCount} active competition{competitor.activeCompetitionsCount !== 1 ? 's' : ''}
                </div>
            )}
        </div>
    );
};

export default CompetitorCard;
